"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRegistrySecondaryNavItems = exports.getRegistryQuickLinks = exports.getRegistryNavItems = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
var _navConstants = require("../constants/navConstants");
var _navIcons = require("../constants/navIcons");
var _dateUtils = require("../util/dateUtils");
var _insertInArrayIf = _interopRequireDefault(require("../util/insertInArrayIf"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Used in web-nav, web-preauth, web-registry, web-store
 */

var parent = _navConstants.PrimaryNavIdentifier.REGISTRY;
var businessUnit = 'REGISTRY';
var getRegistrySecondaryNavItems = exports.getRegistrySecondaryNavItems = function getRegistrySecondaryNavItems(userContext) {
  var shopItem = (0, _dateUtils.isUserPostWedding)(userContext) ? {
    id: _navConstants.SecondaryNavIdentifier.POST_WEDDING_SHOP,
    identifier: _navConstants.SecondaryNavIdentifier.POST_WEDDING_SHOP,
    title: 'Shop',
    path: '/registry/shop',
    parent: parent,
    businessUnit: businessUnit
  } : {
    id: _navConstants.SecondaryNavIdentifier.ADD_GIFTS,
    identifier: _navConstants.SecondaryNavIdentifier.ADD_GIFTS,
    title: 'Add gifts',
    path: '/registry/add-gifts',
    parent: parent,
    businessUnit: businessUnit
  };
  return [shopItem, {
    id: _navConstants.SecondaryNavIdentifier.MANAGE_REGISTRY,
    identifier: _navConstants.SecondaryNavIdentifier.MANAGE_REGISTRY,
    // identifier has been deprecated
    title: 'Manage registry',
    path: '/my-registry',
    parent: parent,
    businessUnit: businessUnit
  }, {
    id: _navConstants.SecondaryNavIdentifier.CHECKLIST,
    identifier: _navConstants.SecondaryNavIdentifier.CHECKLIST,
    title: 'Checklist',
    path: '/registry/checklist',
    parent: parent,
    businessUnit: businessUnit
  }, {
    id: _navConstants.SecondaryNavIdentifier.GIFT_TRACKER,
    identifier: _navConstants.SecondaryNavIdentifier.GIFT_TRACKER,
    title: 'Gift tracker',
    path: '/registry/gift-tracker',
    parent: parent,
    businessUnit: businessUnit
  }];
};
var getRegistryQuickLinks = exports.getRegistryQuickLinks = function getRegistryQuickLinks(registrySlug) {
  var aboutRegistry = {
    id: 'about-registry',
    identifier: 'about-registry',
    title: 'About registry',
    path: '/my-registry',
    showCaret: true,
    parent: parent,
    children: [{
      id: 'registry-perks',
      identifier: 'registry-perks',
      title: 'Perks',
      path: '/wedding-registry/perks',
      parent: parent
    }, {
      id: 'registry-benefits',
      identifier: 'registry-benefits',
      title: 'Why Zola registry',
      path: '/wedding-registry/benefits',
      parent: parent
    }, {
      id: 'how-zola-registry-works',
      identifier: 'how-zola-registry-works',
      title: 'How it works',
      path: '/wedding-registry/how-it-works',
      parent: parent
    }]
  };
  var settings = {
    id: 'account-settings',
    identifier: 'account-settings',
    title: 'Settings',
    path: '/account/settings/info',
    parent: parent
  };
  var previewRegistryPath = "/registry/".concat(registrySlug, "/?preview=true");
  var preview = {
    id: 'preview-registry-dropdown',
    identifier: 'preview-registry-dropdown',
    title: 'Preview',
    showCaret: true,
    path: "".concat(previewRegistryPath),
    parent: parent,
    children: [{
      id: 'preview',
      identifier: 'preview',
      title: 'Preview as guest',
      path: "".concat(previewRegistryPath),
      parent: parent
    }, {
      id: 'copy-registry-link',
      identifier: 'copy-registry-link',
      title: 'Copy link',
      path: "".concat(previewRegistryPath),
      parent: parent
    }]
  };
  return [].concat(_toConsumableArray((0, _insertInArrayIf.default)(!!registrySlug, preview)), [aboutRegistry, settings]);
};
var collectionsDropdownItems = function collectionsDropdownItems(isGuest, showHolidayData, isHomestore) {
  if (showHolidayData && !isHomestore) {
    return [].concat(_toConsumableArray((0, _insertInArrayIf.default)(!isGuest, {
      title: 'Registry Collections',
      path: '/shop/gift-collections/starter-collections'
    })), [{
      title: 'Ultimate Kitchen Essentials',
      path: '/shop/collection/top-kitchen-essentials'
    }, {
      title: 'Registry Essentials',
      path: '/shop/collection/zola-registry-essentials'
    }, {
      title: 'Entertaining Must-Haves',
      path: '/shop/collection/easy-entertaining'
    }, {
      title: '2023 Most Wanted Gifts',
      path: '/shop/collection/most-wanted'
    }, {
      title: 'Gifts Under $100',
      path: '/shop/collection/gifts-under-1002'
    }, {
      title: 'Gifts Under $200',
      path: '/shop/collection/gifts-under-200'
    }, {
      title: 'All Of Your Holiday Must-Haves',
      path: '/shop/collection/all-of-your-holiday-must-haves'
    }], _toConsumableArray((0, _insertInArrayIf.default)(!isGuest, {
      title: 'Quick-Add Packs',
      path: '/registry/quick-add-packs'
    })));
  }
  if (showHolidayData && isHomestore) {
    return [{
      title: '2023 Most Wanted Gifts',
      path: '/shop/collection/most-wanted'
    }, {
      title: 'Stocking Stuffers',
      path: '/shop/collection/stocking-stuffers'
    }, {
      title: 'Gifts Under $100',
      path: '/shop/collection/gifts-under-1002'
    }, {
      title: 'Gifts Under $200',
      path: '/shop/collection/gifts-under-200'
    }, {
      title: 'Splurge Worthy Gifts',
      path: '/shop/collection/splurge-worthy-gifts'
    }, {
      title: 'Cozy Home',
      path: '/shop/collection/cozy-home3'
    }, {
      title: 'Holiday Hosting & Entertaining',
      path: '/shop/collection/gifts-for-entertainers'
    }];
  }
  return [].concat(_toConsumableArray((0, _insertInArrayIf.default)(!isGuest, {
    title: 'Registry Collections',
    path: '/shop/gift-collections/starter-collections'
  })), [{
    title: 'Most Popular Gifts',
    path: '/shop/collection/top-registry-gifts-this-week'
  }, {
    title: 'Registry Essentials',
    path: '/shop/collection/zola-registry-essentials'
  }, {
    title: 'Ultimate Kitchen Essentials',
    path: '/shop/collection/top-kitchen-essentials'
  }, {
    title: 'Entertaining Must-Haves',
    path: '/shop/collection/easy-entertaining'
  }, {
    title: 'Build Your Bar',
    path: '/shop/collection/build-your-bar'
  }, {
    title: 'Gifts Guests Love to Give',
    path: '/shop/collection/guests-favorites'
  }, {
    title: 'Gifts Under $100',
    path: '/shop/collection/gifts-under-100'
  }], _toConsumableArray((0, _insertInArrayIf.default)(!isGuest, {
    title: 'Quick-Add Packs',
    path: '/registry/quick-add-packs'
  })));
};
var brandsDropdownItems = function brandsDropdownItems(brands) {
  var path = '/shop/brands';
  return [{
    title: 'Featured Brands',
    path: path,
    children: [].concat(_toConsumableArray(brands.slice(0, 7).map(function (featureBrand) {
      return {
        title: featureBrand.title,
        path: featureBrand.path === '/shop/brand/crate-barrel' ? '/shop/partner-boutique/crate-barrel' : featureBrand.path
      };
    })), [{
      title: 'View All',
      path: path
    }])
  }];
};
var cashFundsItem = {
  identifier: 'cash-funds',
  title: 'Cash Funds',
  path: '/shop/honeymoon-cash-funds',
  parent: parent,
  showCaret: false,
  dockRight: true,
  centerDropdown: false,
  children: [{
    identifier: 'honeymoon-cash-funds',
    title: 'Cash & Honeymoon Funds',
    path: '/shop/honeymoon-cash-funds'
  }, {
    identifier: 'gift-cards',
    title: 'Gift Cards',
    path: '/shop/category/gift-cards'
  }]
};
var navItemsWithIsActiveAndBusinessUnit = function navItemsWithIsActiveAndBusinessUnit(items, path) {
  return items.map(function (item) {
    var _item$children;
    var children = (_item$children = item.children) === null || _item$children === void 0 ? void 0 : _item$children.map(function (child) {
      var _child$children;
      var grandchildren = (_child$children = child.children) === null || _child$children === void 0 ? void 0 : _child$children.map(function (grandchild) {
        return _objectSpread(_objectSpread({}, grandchild), {}, {
          businessUnit: businessUnit
        });
      });
      return _objectSpread(_objectSpread(_objectSpread({}, child), child.children ? {
        children: grandchildren
      } : {}), {}, {
        businessUnit: businessUnit
      });
    });
    return _objectSpread(_objectSpread(_objectSpread({}, item), item.children ? {
      children: children
    } : {}), {}, {
      businessUnit: businessUnit,
      isActive: Boolean(item.path && path.indexOf(item.path) > -1)
    });
  });
};
var getRegistryNavItems = exports.getRegistryNavItems = function getRegistryNavItems(userContext, registryApiResponse, showHolidayData, isHomestore) {
  var _registryApiResponse$, _registryApiResponse$2;
  var isGuest = userContext ? Boolean(userContext.is_guest) : true;
  var currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
  var brands = registryApiResponse !== null && registryApiResponse !== void 0 && (_registryApiResponse$ = registryApiResponse.brands) !== null && _registryApiResponse$ !== void 0 && _registryApiResponse$.length && registryApiResponse.brands.length > 0 ? registryApiResponse.brands : [];
  var categories = registryApiResponse !== null && registryApiResponse !== void 0 && (_registryApiResponse$2 = registryApiResponse.categories) !== null && _registryApiResponse$2 !== void 0 && _registryApiResponse$2.length && registryApiResponse.categories.length > 0 ? registryApiResponse.categories : [];
  var collectionsIcon = showHolidayData && isHomestore && _navIcons.GIFT_ICON_WHITE || showHolidayData && !isHomestore && _navIcons.GIFT_ICON_RED || undefined;
  var navItems = [{
    identifier: 'new-arrivals',
    title: isGuest ? 'New Arrivals' : 'New',
    path: '/shop/collection/new-arrivals',
    parent: parent
  }, {
    identifier: 'collections',
    activeRegex: /^\/shop\/collection\//,
    title: 'Collections',
    path: '/shop/gift-collections/starter-collections',
    children: collectionsDropdownItems(isGuest, showHolidayData, isHomestore),
    showCaret: false,
    parent: parent,
    icon: collectionsIcon
  }, {
    identifier: 'brands',
    activeRegex: /^\/shop\/brand\//,
    title: 'Brands',
    path: '/shop/brands',
    target: '_self',
    children: brandsDropdownItems(brands),
    showCaret: false,
    multipleSubCategories: true,
    parent: parent
  }].concat(_toConsumableArray(categories.map(function (category) {
    var _category$path;
    return {
      identifier: ((_category$path = category.path) === null || _category$path === void 0 ? void 0 : _category$path.replace('/shop/category/', '')) || '',
      title: category.title,
      path: category.path,
      showCaret: false,
      children: category.children,
      centerDropdown: true,
      parent: parent
    };
  })
  // Remove first cash item b/c BE returns an item w/ no children
  .filter(function (item) {
    return item.title !== 'Cash Funds';
  })), [cashFundsItem]);
  return navItemsWithIsActiveAndBusinessUnit(navItems, currentPath);
};